var _typeof = require("/home/guisjlender/ubuntu-development/workspace/mobicare/mcare-artemis-sdk/node_modules/@babel/runtime/helpers/typeof");

/**
 * Check if `obj` is an object.
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */
function isObject(obj) {
  return null != obj && 'object' == _typeof(obj);
}

module.exports = isObject;